export default {
   // shop data
   intiShop(state, shop = null) {
      state.shop = modifyColumnNames(shop);
   },

}